<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="80%"
      persistent
    >
      <v-card>
        <v-card-title class="privacyPolicy headline lighten-2 justify-center">
          Privacy Policy
        </v-card-title>

        <v-card-text class="pt-5 text-center" style="word-break: keep-all;">
          위던을 즐기기 앞서, 개인정보처리방침과 이용약관에 관하여 동의가 필요해요!
          <br>
          동의 하시겠어요? :)
          <br><br>
          <v-btn 
            class="popupButton"
            @click="showPopup('policy')"
          >개인정보처리방침 보기</v-btn>
          <v-btn 
            class="popupButton"
            @click="showPopup('terms')"
          >이용약관 보기</v-btn>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="$emit('agree')"
          >
            동의합니다!
          </v-btn>
        </v-card-actions>

        <v-expand-transition>
          <v-card 
            v-if="showDialog"
            class="dialogPopup v-card--reveal"
          >
            <div class="dialogContents">
              <Policy v-if="showContent == 1"></Policy>
              <Terms v-else-if="showContent == 2"></Terms>
            </div>

            <v-card-actions>
              <v-btn
                class="close" 
                color="primary" 
                text
                @click="showDialog = false"
              >
                닫기
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-expand-transition>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Policy from '../config/Policy';
  import Terms from '../config/Terms';

  export default {
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
    },
    components: {
      Policy,
      Terms,
    },
    data(){
      return {
        showDialog: false,
        showContent: 1,
      }
    },
    methods: {
      showPopup(value){
        this.showDialog = true;
        if(value == 'policy'){
          this.showContent = 1;
        }else if(value == 'terms'){
          this.showContent = 2;
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
.privacyPolicy{
  &.headline{
    color: #fff;
    font-family: 'Pangolin', 'Noto Sans KR' !important;
    background-color: #ffb5cc;
  }
}
.popupButton{
  width: 100%;
  margin-bottom: 4px;
}
.dialogPopup{
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  
  .dialogContents{
    width: 100%;
    background-color: #fff;
  }
  .v-card__actions{
    width: 100%;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    background-color: #fff;
  }
}
</style>